import NextImageWithShimmer from 'components/image/NextImageWithShimmer';
import { mediaLgMin, mediaXlMin } from 'helpers/breakpoints';
import styled from 'styled-components';

const ParagraphPicPair = ({
  imageSrc,
  altText,
  title,
  content,
  linkText,
  linkUrl,
}: {
  imageSrc: string;
  altText: string;
  title: string;
  content: string;
  linkText: string;
  linkUrl: string;
}) => (
  <Container>
    {/* <img src={imageSrc} alt={altText} /> */}
    <NextImageWithShimmer
      src={imageSrc}
      alt={altText}
      loading="lazy"
      fetchPriority="low"
      sizes="900px"
      width={1000}
      height={1000}
    />
    <ParagraphSection>
      <h2>{title}</h2>
      <p>{content}</p>
      <a href={linkUrl}>{linkText}</a>
    </ParagraphSection>
  </Container>
);

export default ParagraphPicPair;

const Container = styled.div`
  border-radius: 10px;
  //height: 575px;
  overflow: hidden;
  display: grid;
  grid-template-rows: 335px auto;
  margin: 0 20px 56px;
  width: calc(100% - 40px);
  @media ${mediaLgMin} {
    grid-template-columns: 1fr 348px;
    grid-template-rows: 420px;
    //margin: 0 183px;
  }
  @media ${mediaXlMin} {
    margin: 0 auto 56px;
    max-width: 1076px;
    height: 420px;
  }
  img {
    object-fit: cover;
    //height: 335px;
    width: 100%;
    height: 100%;
    align-self: center;
    @media screen and (min-width: 760px) and (max-width: 960px) {
      align-self: flex-start;
      height: 145%;
    }
  }
`;

const ParagraphSection = styled.div`
  background-color: #f4c064;
  padding: 30px;
  color: #17233c;
  @media ${mediaLgMin} {
    padding: 48px;
  }
  h2 {
    font-weight: 700;
    margin-bottom: 10px;
    @media ${mediaLgMin} {
      font-size: 32px !important;
      line-height: 38px !important;
    }
    font-size: 24px;
  }
  p {
    margin-bottom: 10px;
  }
  a {
    color: #17233c;
    font-weight: 700;
    text-decoration: underline;
  }
  @media ${mediaLgMin} {
    a,
    p {
      font-size: 20px;
      line-height: 130%;
    }
  }
`;
